import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=89466b36&scoped=true"
import script from "./FeedbackCard.vue?vue&type=script&lang=js"
export * from "./FeedbackCard.vue?vue&type=script&lang=js"
import style0 from "./FeedbackCard.vue?vue&type=style&index=0&id=89466b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89466b36",
  null
  
)

export default component.exports